module.exports = __webpack_public_path__ + "img/6.74cd47ae.svg";